// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";

@jsonObject()
export default class GetDecimals extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;

  constructor(asset: ChannelAsset) {
    super();
    this.asset = asset;
  }

  messageType(): MessageType {
    return GetDecimals;
  }

  messageTypeName(): MessageTypeName {
    return "GetDecimals";
  }

  static fromJSON(json: any): GetDecimals {
    const asset = deserializeChannelAsset(json.asset);
    return new GetDecimals(asset);
  }

  toJSON(): any {
    console.log("GetDecimals.toJSON");
    return {
      asset: serializeChannelAsset(this.asset),
    };
  }
}
